import { getAuth } from 'firebase/auth';

const BASE = process.env.REACT_APP_BACKEND_URL;

async function headers() {
  const user = getAuth().currentUser;
  if (!user) throw new Error('Not authenticated');
  const token = await user.getIdToken();
  return { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
}

async function request(method, path, body) {
  const h = await headers();
  const opts = { method, headers: h };
  if (body) opts.body = JSON.stringify(body);
  const res = await fetch(`${BASE}${path}`, opts);
  const data = await res.json();
  if (!res.ok) {
    const err = new Error(data.detail?.message || data.detail || 'Request failed');
    err.status = res.status;
    err.data   = data;
    throw err;
  }
  return data;
}

export const api = {
  get:    (path)       => request('GET',    path),
  post:   (path, body) => request('POST',   path, body),
  put:    (path, body) => request('PUT',    path, body),
  delete: (path)       => request('DELETE', path),
};
